/* eslint-disable */ 
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Tabs, Tab, Row, Col, Table } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { DIVISIONS,SchoolAverageHeaders } from '../../../utils/constants';
import { divisionSchoolAverageFilter } from '../../../utils/functions';
import  Navwrapper  from '../../layout/Navigation';
import Footer from '../../layout/Footer';
import { getSchoolAverageBySeason  } from '../api'
import { exportCSV, tableOptions} from '../common'

export default class SchoolAveragePage extends Component {

  constructor(props) {
    super(props);
    const { match } = this.props
    this.state = {      
      schoolAverages:[],
      seasonId:match.params.seasonId,
      eventId:match.params.eventId,
      teamId:match.params.teamId
    };
  }
  
  componentDidMount() {

      const _this = this

      getSchoolAverageBySeason(_this.state.seasonId,_this.state.eventId,_this.state.teamId).then(function(response) {
           _this.setState({ schoolAverages: response.data }) 
      });

   }  

  playerNameFormatter(cell, row ) {
    var link = `/playerProfile/${row.seasonId}/${row.playerId}`;
  return <Link to={link}>{cell}</Link>;      
  }  
  totalsRow(tabData) {
    
    var firstRow =tabData[0];
    var bowlersInField = 0;
    var firstRow =tabData[0];
    var individualFieldAvg = '';
    var maxGamesBowled = 0;  
    var totalTeamGames = 0;
    var totalTeamGM = 0;
    var totalTeamAVG = 0;
    var totalBaker = 0;
    var totalBakerGM = 0;
    var totalBakerAVG = 0;
    var totalFinal=0;
    
     if (tabData.length > 0) {
        maxGamesBowled = Math.max.apply(Math, tabData.map(function(b) { return b.gm; })) ;
        bowlersInField  = firstRow.bowlersInField;
        individualFieldAvg = firstRow.eventFieldAvg;  

        totalTeamGames = tabData.reduce( function(cnt,i){ return cnt + i.total; },0); 
        totalTeamGM = firstRow.teamGames;
        totalTeamAVG = (totalTeamGames/totalTeamGM).toFixed(3);
        totalBaker = firstRow.bakerTotal;
        totalBakerGM = firstRow.bakerGames; 
        totalBakerAVG = (totalBaker/totalBakerGM).toFixed(3);
        totalFinal = totalTeamGames + totalBaker;
      }
    
    return  <React.Fragment>
            <Row>
                 <Col xs={3} />   
                 <Col xs={6}  className="totals_table">
                        <Table className="table_greybackground">
                          <thead >
                            <tr >
                              <th/>
                              <th>TOTAL</th>
                              <th>GM</th>
                              <th>AVG</th>                                
                            </tr>
                          </thead>                          
                          <tbody>
                            <tr >
                              <td>TOTAL: Team Games</td>
                              <td>{totalTeamGames}</td>
                              <td>{totalTeamGM}</td>
                              <td>{totalTeamAVG}</td>
                            </tr>       
                            <tr>
                            <td>TOTAL: Baker Games</td>
                              <td>{totalBaker}</td>
                              <td>{totalBakerGM}</td>
                              <td>{totalBakerAVG}</td>
                            </tr>   
                            <tr>
                            <td>TOTAL: Final Score</td>
                              <td>{totalFinal}</td>
                              <td></td>
                              <td></td>
                            </tr>                               
                          </tbody>
                        </Table>                 
                 </Col>      
            </Row>
            <Row >
              <Col xs={3} />              
              <Col xs={6}>                                                
                <Table className="totals_table"  >
                  <thead >
                    <tr >
                      <th/>
                      <th/>
                      <th/>
                      <th/>                                
                    </tr>
                  </thead>
                  <tbody>
                    <tr >
                      <td>Individual Field Average:</td>
                      <td>{individualFieldAvg}</td>
                      <td>Bowlers in Field:</td>
                      <td>{bowlersInField}</td>
                    </tr>       
                    <tr>
                      <td>Max Games Bowled:</td>
                      <td>{maxGamesBowled}</td>
                    </tr>   
                  </tbody>
                </Table>
              </Col>
            </Row>
            </React.Fragment>;                    
  }
  render() {  
    const _this = this
    const { match } = this.props
    const school = match.params.teamName
    const currentSeason = match.params.seasonName
    const tournament = match.params.eventName
    const averagesMen = match.params.averagesMen 
    const averagesVar = match.params.averagesVar
 
  const SchoolAveragesAll =_this.state.schoolAverages;
  const menSchoolAverages = SchoolAveragesAll
                      .filter((averages) => divisionSchoolAverageFilter(averages, DIVISIONS.MEN, DIVISIONS.VARSITY));
  const womenSchoolAverages = SchoolAveragesAll
                      .filter((averages) => divisionSchoolAverageFilter(averages, DIVISIONS.WOMEN, DIVISIONS.VARSITY));
  const menJVSchoolAverages = SchoolAveragesAll
                      .filter((averages) => divisionSchoolAverageFilter(averages, DIVISIONS.MEN, DIVISIONS.JV));
  const womenJVSchoolAverages = SchoolAveragesAll
                      .filter((averages) => divisionSchoolAverageFilter(averages, DIVISIONS.WOMEN, DIVISIONS.JV));
  
  var defaultTab = DIVISIONS.MENTAB;
  if (averagesMen === 'false') {
    defaultTab = DIVISIONS.WOMENTAB;
    if (averagesVar=== 'false') {
      defaultTab =  DIVISIONS.WOMENJBTAB;
    }
  } 
  else {
    if (averagesVar=== 'false') {
      defaultTab = DIVISIONS.MENJVTAB;
    }
  }                     
  return (
    <div>
      <Navwrapper />
      <div className="container-fluid">
        <Row>
          <div className="pageHeading" >
              <h4>{currentSeason}</h4>
                <h4 >
                    {tournament}<br/>
                    Individual Averages - {school}
                </h4>
          </div>
        </Row>      
        <Row>                 
          <Col xs={12} >                           
            <div className="rankingRightColumn_"> 
              <Tabs defaultActiveKey={defaultTab} id="ind-avg-school-tabs">
                <Tab eventKey={1} title="VARSITY MEN">           
                    <BootstrapTable 
                      data={menSchoolAverages} 
                      striped 
                      hover 
                      options={tableOptions}
                      pagination               
                    >
                        <TableHeaderColumn          
                          dataField="Id" 
                          isKey 
                          dataAlign="right" 
                          dataSort 
                          data-Visible="false"               
                          hidden                 
                        >ID
                        </TableHeaderColumn>
                        <TableHeaderColumn dataField="no" dataSort width="2%" >NO
                        </TableHeaderColumn>
                        <TableHeaderColumn 
                          dataField="name" 
                          dataAlign="left"
                          dataFormat={this.playerNameFormatter}  
                          width="2%" 
                        >NAME
                        </TableHeaderColumn>
                        <TableHeaderColumn dataField="school" dataAlign="left"  width="2%" >SCHOOL
                        </TableHeaderColumn>
                        <TableHeaderColumn 
                          dataField="tm" 
                          dataAlign="right"  
                          width="2%" 
                        >TM
                        </TableHeaderColumn>
                        <TableHeaderColumn dataField="total" dataAlign="right"  width="2%" >TOTAL
                        </TableHeaderColumn>
                        <TableHeaderColumn dataField="gm" dataAlign="right"  width="2%" >GM
                        </TableHeaderColumn>
                        <TableHeaderColumn dataField="avg" dataAlign="right"  width="2%" >AVG
                        </TableHeaderColumn>                  
                    </BootstrapTable>
                  
                    <Row className="blank_row" />
                    { exportCSV(menSchoolAverages,SchoolAverageHeaders,'MenSchoolAverages - '+ tournament +'.csv') }
                    {this.totalsRow(menSchoolAverages)}
                </Tab>
                <Tab eventKey={2} title="VARSITY WOMEN">
                      <BootstrapTable 
                        data={womenSchoolAverages} 
                        striped 
                        hover 
                        options={tableOptions}
                        pagination               
                      >
                          <TableHeaderColumn          
                            dataField="Id" 
                            isKey 
                            dataAlign="right" 
                            dataSort 
                            data-Visible="false"               
                            hidden                 
                          >ID
                          </TableHeaderColumn>
                          <TableHeaderColumn dataField="no" dataSort width="2%" >NO
                          </TableHeaderColumn>
                          <TableHeaderColumn 
                            dataField="name" 
                            dataAlign="left"
                            dataFormat={this.playerNameFormatter}  
                            width="2%" 
                          >NAME
                          </TableHeaderColumn>
                          <TableHeaderColumn dataField="school" dataAlign="left"  width="2%" >SCHOOL
                          </TableHeaderColumn>
                          <TableHeaderColumn 
                            dataField="tm" 
                            dataAlign="right"  
                            width="2%" 
                          >TM
                          </TableHeaderColumn>
                          <TableHeaderColumn dataField="total" dataAlign="right"  width="2%" >TOTAL
                          </TableHeaderColumn>
                          <TableHeaderColumn dataField="gm" dataAlign="right"  width="2%" >GM
                          </TableHeaderColumn>
                          <TableHeaderColumn dataField="avg" dataAlign="right"  width="2%" >AVG
                          </TableHeaderColumn>                  
                      </BootstrapTable>

                      <Row className="blank_row" />
                      { exportCSV(womenSchoolAverages,SchoolAverageHeaders,'WomenSchoolAverages - '+ tournament +'.csv') }
                      {this.totalsRow(womenSchoolAverages)}
                </Tab>

                <Tab eventKey={3} title="JUNIOR VARSITY MEN">           
                    <BootstrapTable 
                      data={menJVSchoolAverages} 
                      striped 
                      hover 
                      options={tableOptions}
                      pagination               
                    >
                        <TableHeaderColumn          
                          dataField="Id" 
                          isKey 
                          dataAlign="right" 
                          dataSort 
                          data-Visible="false"               
                          hidden                 
                        >ID
                        </TableHeaderColumn>
                        <TableHeaderColumn dataField="no" dataSort width="2%" >NO
                        </TableHeaderColumn>
                        <TableHeaderColumn 
                          dataField="name" 
                          dataAlign="left"
                          dataFormat={this.playerNameFormatter}  
                          width="2%" 
                        >NAME
                        </TableHeaderColumn>
                        <TableHeaderColumn dataField="school" dataAlign="left"  width="2%" >SCHOOL
                        </TableHeaderColumn>
                        <TableHeaderColumn 
                          dataField="tm" 
                          dataAlign="right"  
                          width="2%" 
                        >TM
                        </TableHeaderColumn>
                        <TableHeaderColumn dataField="total" dataAlign="right"  width="2%" >TOTAL
                        </TableHeaderColumn>
                        <TableHeaderColumn dataField="gm" dataAlign="right"  width="2%" >GM
                        </TableHeaderColumn>
                        <TableHeaderColumn dataField="avg" dataAlign="right"  width="2%" >AVG
                        </TableHeaderColumn>                  
                    </BootstrapTable>
                  
                    <Row className="blank_row" />
                    { exportCSV(menJVSchoolAverages,SchoolAverageHeaders,'MenJVSchoolAverages - '+ tournament +'.csv') }
                    {this.totalsRow(menJVSchoolAverages)}
                </Tab>
                <Tab eventKey={4} title="JUNIOR VARSITY WOMEN">
                      <BootstrapTable 
                        data={womenJVSchoolAverages} 
                        striped 
                        hover 
                        options={tableOptions}
                        pagination               
                      >
                          <TableHeaderColumn          
                            dataField="Id" 
                            isKey 
                            dataAlign="right" 
                            dataSort 
                            data-Visible="false"               
                            hidden                 
                          >ID
                          </TableHeaderColumn>
                          <TableHeaderColumn dataField="no" dataSort width="2%" >NO
                          </TableHeaderColumn>
                          <TableHeaderColumn 
                            dataField="name" 
                            dataAlign="left"
                            dataFormat={this.playerNameFormatter}  
                            width="2%" 
                          >NAME
                          </TableHeaderColumn>
                          <TableHeaderColumn dataField="school" dataAlign="left"  width="2%" >SCHOOL
                          </TableHeaderColumn>
                          <TableHeaderColumn 
                            dataField="tm" 
                            dataAlign="right"  
                            width="2%" 
                          >TM
                          </TableHeaderColumn>
                          <TableHeaderColumn dataField="total" dataAlign="right"  width="2%" >TOTAL
                          </TableHeaderColumn>
                          <TableHeaderColumn dataField="gm" dataAlign="right"  width="2%" >GM
                          </TableHeaderColumn>
                          <TableHeaderColumn dataField="avg" dataAlign="right"  width="2%" >AVG
                          </TableHeaderColumn>                  
                      </BootstrapTable>

                      <Row className="blank_row" />
                      { exportCSV(womenJVSchoolAverages,SchoolAverageHeaders,'WomenJVSchoolAverages - '+ tournament +'.csv') }
                      {this.totalsRow(womenJVSchoolAverages)}                    
                </Tab>

              </Tabs>
            </div>
          </Col>
        </Row>
      </div>
      <Footer />
    </div>
  );
  }  
}


// WEBPACK FOOTER //
// ./src/components/pages/schoolAverage/index.js